import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { ActionPracticesService } from '@services/data-source-tables/action-practices.service';
import { ActionPracticesModel } from '@/models/tables/action-practices.model';

@Component({
  selector: 'app-button-action-practice-delete',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeleteActionPracticeComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private actionPractice: ActionPracticesModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected actionPracticeService: ActionPracticesService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.actionPractice = <ActionPracticesModel>this.rowData;
  }

  /**
   * Delete user
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteSubAgent) => {
      if (deleteSubAgent) {
        this.actionPracticeService.deleteActionPractice(this.actionPractice.id).subscribe({
          next: () => {
            this.toastr.success('Azione Pratica cancellata correttamente!');

            Registry.getInstance().get('ActionPracticesComponent').loadActionPractices();
          },
          error: (error) => {
            LoggerService.error('deleteSubAgent failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione dell'Azione Pratica.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questa azione pratica?';
    dialogRef.componentInstance.content =
      "Attenzione una volta cancellata l'azione pratica non sarà più possibile recuperarla.";
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
